import React from 'react';
import { Radio, Input } from '../../../common/components/formControls';
import { Form, Panel, Row, Col } from 'react-bootstrap';
import { Field } from 'redux-form';
import withResourcesNamespace from '../../../common/components/withResourcesNamespace';
import validators from '../../../common/services/validators';

const PrimitiveReflexAssessment = ({ t, isReadOnly }) => {
	const colSize = { labelCol: 4, valueCol: 8 };
	const grades = [
		{ value: '0', label: '0' },
		{ value: '1', label: '1' },
		{ value: '2', label: '2' },
		{ value: '3', label: '3' },
		{ value: '4', label: '4' },
		{ value: '-1', label: t('CNP') }
	];

	return (
		<Form >
			<Panel>
				<Panel.Heading>{t('PrimitiveReflex')}</Panel.Heading>
				<Panel.Body>
					<Field name='tlr' component={Radio} entries={grades} parse={value => Number(value)} inline horizontal required label={t('TLR')} disabled={isReadOnly} {...colSize} />
					<Field name='atnrStandingRight' component={Radio} entries={grades} parse={value => Number(value)} inline horizontal required label={`${t('ATNR_Standing')} - ${t('Right')}`} disabled={isReadOnly} {...colSize} />
					<Field name='atnrStandingLeft' component={Radio} entries={grades} parse={value => Number(value)} inline horizontal required label={`${t('ATNR_Standing')} - ${t('Left')}`} disabled={isReadOnly} {...colSize} />
					<Field name='moro' component={Radio} entries={grades} parse={value => Number(value)} inline horizontal required label={t('Moro')} disabled={isReadOnly} {...colSize} />
					<Field name='atnrKneelingRight' component={Radio} entries={grades} parse={value => Number(value)} inline horizontal required label={`${t('ATNR_Kneeling')} - ${t('Right')}`} disabled={isReadOnly} {...colSize} />
					<Field name='atnrKneelingLeft' component={Radio} entries={grades} parse={value => Number(value)} inline horizontal required label={`${t('ATNR_Kneeling')} - ${t('Left')}`} disabled={isReadOnly} {...colSize} />
					<Field name='stnr' component={Radio} entries={grades} parse={value => Number(value)} inline horizontal required label={t('STNR')} disabled={isReadOnly} {...colSize} />
					<Field name='spinalGalantRight' component={Radio} entries={grades} parse={value => Number(value)} inline horizontal required label={`${t('SpinalGalant')} - ${t('Right')}`} disabled={isReadOnly} {...colSize} />
					<Field name='spinalGalantLeft' component={Radio} entries={grades} parse={value => Number(value)} inline horizontal required label={`${t('SpinalGalant')} - ${t('Left')}`} disabled={isReadOnly} {...colSize} />
					<Field name='palmerRight' component={Radio} entries={grades} parse={value => Number(value)} inline horizontal required label={`${t('Palmer')} - ${t('Right')}`} disabled={isReadOnly} {...colSize} />
					<Field name='palmerLeft' component={Radio} entries={grades} parse={value => Number(value)} inline horizontal required label={`${t('Palmer')} - ${t('Left')}`} disabled={isReadOnly} {...colSize} />
					<Field name='rootingRight' component={Radio} entries={grades} parse={value => Number(value)} inline horizontal required label={`${t('Rooting')} - ${t('Right')}`} disabled={isReadOnly} {...colSize} />
					<Field name='rootingLeft' component={Radio} entries={grades} parse={value => Number(value)} inline horizontal required label={`${t('Rooting')} - ${t('Left')}`} disabled={isReadOnly} {...colSize} />
					<Field name='babinskyRight' component={Radio} entries={grades} parse={value => Number(value)} inline horizontal required label={`${t('Babinsky')} - ${t('Right')}`} disabled={isReadOnly} {...colSize} />
					<Field name='babinskyLeft' component={Radio} entries={grades} parse={value => Number(value)} inline horizontal required label={`${t('Babinsky')} - ${t('Left')}`} disabled={isReadOnly} {...colSize} />

				</Panel.Body>
			</Panel>
		</Form>
	);
};

export const RequiredFields = [
	'tlr',
	'atnrStandingRight',
	'atnrStandingLeft',
	'moro',
	'atnrKneelingRight',
	'atnrKneelingLeft',
	'stnr',
	'spinalGalantRight',
	'spinalGalantLeft',
	'palmerRight',
	'palmerLeft',
	'rootingRight',
	'rootingLeft',
	'babinskyRight',
	'babinskyLeft'
];

export default withResourcesNamespace(props => props.resourcesNamespace)(PrimitiveReflexAssessment);